<script lang="ts" setup>
import { useUserStore, useGlobalStore } from '@/stores';

const props = defineProps({
    eventId: {
        type: Number,
        default: null,
    },
    isFavorite: {
        type: Boolean,
        default: false,
    },
})
const userStore = useUserStore()
const globalStore = useGlobalStore()

const isFavorite = ref(props.isFavorite);

const toggle = async () => {
    // userStore.fetchToggleFavoriteEvent(id)
    if (!userStore.isLoggedIn) {
        globalStore.setDialogVisible({
            needLogin: true,
            visible: true,
            title: '提示',
            message: '請先登入會員。',
            banner: 8
        })
    } else {
        if (props.eventId) {
            try {
                await userStore.fetchToggleFavoriteEvent(props.eventId as any)
                isFavorite.value = !isFavorite.value
            } catch (error) {
                console.error('收藏活動失敗:', error);
                globalStore.setDialogVisible({
                    visible: true,
                    title: '提示',
                    message: '收藏活動失敗，請聯絡我們。',
                })
            }
        }
    }
}

</script>

<template>
    <button @click="toggle"><svg-icon :name="isFavorite ? 'icon-favorite-has' : 'icon-favorite'" />收藏</button>
</template>

<style lang="scss" scoped>
.card2 {
    &__fav {
        display: flex;
        align-items: center;
        border: none;
        background: transparent;
        color: $color-gray-1;

        svg {
            width: toRem(21);
            height: toRem(21);
            margin-right: toRem(3);
        }
    }

}

.card3 {
    &__fav {
        display: flex;
        align-items: center;
        border: none;
        background: transparent;
        color: $color-brand-4_1;

        svg {
            width: toRem(21);
            height: toRem(21);
            margin-right: toRem(3);
        }
    }
}
</style>
